import React from 'react';
import PropTypes from 'prop-types';

const DataTable = ({ columns, rows, highlightIndex }) => (
  <div className="o-data-table-wrapper">
    <table className="o-data-table">
      <thead>
        <tr>
          {columns.map((col) => (
            <th key={col.key}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i} className={i === highlightIndex ? 'o-data-table__highlight' : ''}>
            {columns.map((col) => (
              <td key={col.key}>
                {col.format ? col.format(row[col.key]) : row[col.key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

DataTable.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      format: PropTypes.func,
    })
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  highlightIndex: PropTypes.number,
};

export default DataTable;
